import { PageLayout } from "../components/PageLayout.js";

export function TenantOverview() {
  return (
    <PageLayout title="Overview">
      <div className="overviewTiles">
        {[1, 2, 3, 4, 5, 6].map((index) => (
          <div className="overviewTile" key={index}>
            <div className="overviewTileValue">-</div>
            <div className="overviewTileLabel">Tile {index}</div>
          </div>
        ))}
      </div>

      <div className="overviewSparkline">Chart coming soon</div>
      <div className="overviewSparkline">Chart coming soon</div>
    </PageLayout>
  );
}
